import {IGradesRepository} from './IGradesRepository';
import {Amplify} from 'aws-amplify';
import {
  InitWithAmplify,
  InitEnvironmentVariable,
  GradeService as PikadoGradeService,
  CreateNewGradeInput,
  UpdateNewGradeInput,
} from '@PikaDoApp/npm-pikado-logic';
import {getEnvironment} from '../../lib/getEnvironment';
import {GradeUI} from './GradeTypes';

// Initialize the Pikado Logic package
InitWithAmplify(Amplify);
InitEnvironmentVariable(getEnvironment());

const pikadoGradeService = new PikadoGradeService();

export class GradesRepository implements IGradesRepository {
  async getGrades(): Promise<Array<GradeUI>> {
    try {
      const resp = await pikadoGradeService.getGrades(100, 1);
      const grades = resp.items;

      if (!grades) {
        return [];
      }

      // Map _id to id for UI compatibility
      return grades.map(grade => ({
        ...grade,
        id: grade._id,
      }));
    } catch (error) {
      console.error(
        '🔍 [GRADE-NEW-PACKAGE] getGrades repository Error:',
        error,
      );
      throw error;
    }
  }

  async getNewGradeById(id: string): Promise<GradeUI | null> {
    try {
      const grade = await pikadoGradeService.getGradeById(id);

      if (!grade) {
        return null;
      }

      // Map _id to id for UI compatibility
      return {
        ...grade,
        id: grade._id,
      };
    } catch (error) {
      console.error(
        '🔍 [GRADE-NEW-PACKAGE] getNewGradeById repository Error:',
        error,
      );
      throw error;
    }
  }

  async createNewGrade(input: CreateNewGradeInput): Promise<GradeUI | null> {
    try {
      const createdGrade = await pikadoGradeService.createGrade(input);

      if (!createdGrade) {
        return null;
      }

      // Map _id to id for UI compatibility
      return {
        ...createdGrade,
        id: createdGrade._id,
      };
    } catch (error) {
      console.error(
        '🔍 [GRADE-NEW-PACKAGE] createNewGrade repository Error:',
        error,
      );
      throw error;
    }
  }

  async updateNewGrade(input: UpdateNewGradeInput): Promise<GradeUI | null> {
    try {
      const updatedGrade = await pikadoGradeService.updateGrade(input);

      if (!updatedGrade) {
        return null;
      }

      // Map _id to id for UI compatibility
      return {
        ...updatedGrade,
        id: updatedGrade._id,
      };
    } catch (error) {
      console.error(
        '🔍 [GRADE-NEW-PACKAGE] updateNewGrade repository Error:',
        error,
      );
      throw error;
    }
  }

  async deleteNewGrade(id: string): Promise<any> {
    try {
      const result = await pikadoGradeService.softDeleteGrade(id);
      return result;
    } catch (error) {
      console.error(
        '🔍 [GRADE-NEW-PACKAGE] deleteNewGrade repository Error:',
        error,
      );
      throw error;
    }
  }
}
